import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=2c682235&scoped=true&"
import script from "./InvoiceList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceList.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=2c682235&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c682235",
  null
  
)

export default component.exports